package com.dignicate.web.domain

/** Navigation labels for top tabs (resolved to strings in repository/usecase) */
data class NavigationLabels(
    val about: String,
    val services: String,
    val products: String,
    val values: String,

    // Add company label for the Company page navigation
    val companyLabel: String = "Company",

    // UI setting labels
    val languageLabel: String = "Language",
    val languageOptionSystem: String = "System",
    val languageOptionJa: String = "日本語",
    val languageOptionEn: String = "English",

    val themeLabel: String = "Theme",
    val themeOptionSystem: String = "System",
    val themeOptionLight: String = "Light",
    val themeOptionDark: String = "Dark"
)
